import RequestUserDataContent from './request-user-data-content'

export default RequestUserDataContent
